import { GoogleIcon } from '@braskai/icons';
import { Button, type ButtonProps } from '@braskai/ui-kit';

import { CircularProgress, styled } from '@mui/material';

export const Loader = styled(({ ...props }) => <CircularProgress {...props} size={24} />)(({ theme }) => ({
  color: theme.palette.grey[300],
}));

export const SubmitButton = styled((props: ButtonProps) => (
  <Button
    size="xl"
    startIcon={props.isLoading ? <Loader /> : <GoogleIcon height="24" width="24" />}
    variant="outlined"
    {...props}
  />
))({
  height: 52,
});
